// import React,  { useState } from 'react'
// import UserSidebar from './Components/UserSidebar'
// // import { Link } from 'react-router-dom'
// import { ethers } from 'ethers'
// import Web3Modal from 'web3modal'
// import { create as ipfsHttpClient } from "ipfs-http-client";
// import NFTMarketplace from '../artifacts/contracts/NFTMarketplace.sol/NFTMarketplace.json';
// import nftmarketaddress from '../config'
// import { useNavigate } from 'react-router-dom';
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from 'axios'
// import { ThreeSixtyRounded } from '@mui/icons-material';
// const fs = require('fs');
// // const axios = require('axios');


// const Orders = () => {
//   let imageUrl="";
//   const [minted, setMinted] = useState(false);
//   const projectId = "2LYV9kyxorwvJiMS5DxpEOwLxMy";
// const projectSecret = "c5927cc35e654ef1a4137d1ac95cf8dc";
// const authorization = "Basic " + btoa(projectId + ":" + projectSecret);
// // const client = ipfsHttpClient('https://ipfs.infura.io:5001/api/v0/')
// const client = ipfsHttpClient({
//   url: "https://ipfs.infura.io:5001/api/v0",
//   headers:{
//     authorization
//   }
// })
//   let wAddressLocalget = JSON.parse(localStorage.getItem('wAddressLocal'));
//   console.log(wAddressLocalget);

//   const navigate = useNavigate();
//   const [fileUrl, setFileUrl] = useState(null)
//   const [formInput, updateFormInput] = useState({ price: '', name: '', description: '' })

//   async function onChange(e) {
//     const file = e.target.files[0]
//     try {
//       const added = await client.add(file);
//       const url = `https://mint-blocks-nfts.infura-ipfs.io/ipfs/${added.path}`
//       setFileUrl(url)
//       console.log(url)
//     } catch (error) {
//       console.log('Error uploading file: ', error)
//     }  
//   }
//   async function uploadToIPFS() {
    
//     const { name, description, price } = formInput
//     if (!name || !description || !price || !fileUrl) return
//     /* first, upload to IPFS */
//     const data = JSON.stringify({
//       name, description, image: fileUrl
//     })
//     try {
//       const added = await client.add(data)
//       const url = `https://mint-blocks-nfts.infura-ipfs.io/ipfs/${added.path}`
//       imageUrl=fileUrl
//       return url
//     } catch (error) {
//       console.log('Error uploading file: ', error)
//     }  
//   }
//   async function listNFTForSale() {
//     const url = await uploadToIPFS();
  
//     // Check if there is a Web3 provider (i.e. Metamask) and if the user is connected
//     if (typeof window !== 'undefined' && typeof window.ethereum !== 'undefined') {
//       try {
//         // Request user's permission to connect their Metamask account
//         await window.ethereum.request({ method: 'eth_requestAccounts' });
  
//         // Initialize Web3Modal with the injected Ethereum provider from Metamask
//         const web3Modal = new Web3Modal({
//           network: 'mainnet', // Or the Ethereum network ID you want to connect to
//           cacheProvider: true,
//         });
//         const connection = await web3Modal.connect();
//         const provider = new ethers.providers.Web3Provider(connection);
//         const signer = provider.getSigner();
//         // Get the owner and seller addresses
//         const ownerAddress = await provider.getSigner().getAddress();
//         const sellerAddress = await provider.getSigner().getAddress();
  
//         // Create the NFT item
//         const contract = new ethers.Contract(nftmarketaddress, NFTMarketplace.abi, signer);
//         const price = ethers.utils.parseUnits(formInput.price, 'ether');
//         let listingPrice = await contract.getListingPrice();
//         listingPrice = listingPrice.toString();
//         let transaction = await contract.createToken(url, price, { value: listingPrice });
//         let receipt = await transaction.wait();
//         const tokenId = parseInt(receipt.logs[1].topics[3], 16); // Get the tokenId from the receipt
//         console.log("tokenId", tokenId)
//         // Create the data object to be sent to the database
//         const data = {
//           tokenId: tokenId,
//           name: formInput.name,
//           description: formInput.description,
//           price: formInput.price,
//           fileUrl: imageUrl,
//           ownerAddress: ownerAddress,
//           sellerAddress: sellerAddress,
//           isApproved: false //should be false in real, this is just for testing
//         };
  
//         // Send the data object to the database
 
//         const response = await axios.post('https://mint-blocks-api-production.up.railway.app/nfts', data);
//     console.log('Response from the server:', response.data);
//     setMinted(true); // Set the minted state to true
//     toast.success("NFT minted successfully and sent to admin for approval.")
//     navigate('/user-dashboard/creator');
  
//       } catch (error) {
//         console.error('Error:', error);
  
//         if (error.response && error.response.data) {
//           console.log('Validation errors:', error.response.data);
//         }
//       }
//     } else {
//       // Display an error message if the user is not connected to Metamask
//       console.error('Please install Metamask or connect to the Ethereum network.');
//     }
//   }
  
  



//   // const onSubmitHandler = async (event) => {
//   //   event.preventDefault();
//   //   const form = event.target;
//   //   const files = (form[0]).files;

//   //   if (!files || files.length === 0) {
//   //     return alert("No files selected");
//   //   }

//   //   const file = files[0];
//   //   // upload files
//   //   const result = await client.add(file);

//   //   setImages([
//   //     ...images,
//   //     {
//   //       cid: result.cid,
//   //       path: result.path,
//   //     },
//   //   ]);

//   //   form.reset();
//   // };

//   if (wAddressLocalget !== null) {
//   return (
//     <div>
//        <div className="container user-dashboard-page">
//             <div className="user-sidebar">
//                 <UserSidebar />

//             </div>
//             <div className="user-main  container ms-3">
//         <div className="heading">
//             <h3 className="mt-3">
//               Add New NFT
//             </h3>
// {/* <form>
//   <div className="form-group">
//     <label htmlFor="exampleFormControlInput1">Title</label>
//     <input
//       type="text"
//       className="form-control"
//       id="exampleFormControlInput1"
//       onChange={e => updateFormInput({ ...formInput, name: e.target.value })}
//       required
//     />
//   </div>
//   <div className="form-group">
//     <label htmlFor="price">Price</label>
//     <input
//       type="number"
//       className="form-control"
//       id="price"
//       onChange={e => updateFormInput({ ...formInput, price: e.target.value })}
//       required
//     />
//   </div>
//   <div className="form-group">
//     <label htmlFor="exampleFormControlTextarea1">Description</label>
//     <textarea
//       className="form-control"
//       id="exampleFormControlTextarea1"
//       rows="3"
//       onChange={e => updateFormInput({ ...formInput, description: e.target.value })}
//       required
//     ></textarea>
//   </div>
//   <div className="form-group">
//     <label htmlFor="exampleFormControlFile1">Image</label><br/>
//     <input
//       type="file"
//       className="form-control-file"
//       id="exampleFormControlFile1"
//       name="Asset"
//       onChange={onChange}
//       required
//     />
//     {fileUrl && (
//       <img height="200px" src={fileUrl} alt="Nft image" />
//     )}
//   </div>
//   <small className="text-muted">Please upload a 1:1 image for the best preview.</small>
//   <button type="button" onClick={listNFTForSale} className="btn btn-primary mt-3">Upload</button>
// </form> */}
// <form>
//   <div className="form-group">
//     <label htmlFor="exampleFormControlInput1">Title</label>
//     <input
//       type="text"
//       className="form-control"
//       id="exampleFormControlInput1"
//       onChange={e => updateFormInput({ ...formInput, name: e.target.value })}
//       required
//     />
//   </div>
//   <div className="form-group">
//     <label htmlFor="price">Price</label>
//     <input
//       type="number"
//       className="form-control"
//       id="price"
//       onChange={e => updateFormInput({ ...formInput, price: e.target.value })}
//       required
//     />
//   </div>
//   <div className="form-group">
//     <label htmlFor="exampleFormControlTextarea1">Description</label>
//     <textarea
//       className="form-control"
//       id="exampleFormControlTextarea1"
//       rows="3"
//       onChange={e => updateFormInput({ ...formInput, description: e.target.value })}
//       required
//     ></textarea>
//   </div>
//   <div className="form-group">
//     <label htmlFor="exampleFormControlFile1">Image</label><br/>
//     <input
//       type="file"
//       className="form-control-file"
//       id="exampleFormControlFile1"
//       name="Asset"
//       onChange={onChange}
//       required
//     />
//     {fileUrl && (
//       <img height="200px" src={fileUrl} alt="Nft image" />
//     )}
//   </div>
//   <small className="text-muted">Please upload a 1:1 image for the best preview.</small>
//   <br/>
//   <button type="button" onClick={listNFTForSale} className="btn btn-primary mt-3">Upload</button>
// </form>

// {minted && (
//   <div className="alert alert-success mt-3" role="alert">
//     NFT minted successfully! It has been sent to the admin for approval.
//   </div>
// )}
//  {/* {client && (
//         <>
//           <h3>Upload file to IPFS</h3>
//           <form onSubmit={onSubmitHandler}>
//             <input type="file" name="file"/>
//             <button type="submit">Upload file</button>
//           </form>
//           <div>
//         {images.map((image, index) => (
//           <img
//           alt={`Uploaded #${index + 1}`}
//           src={"https://mint-blocks-nfts.infura-ipfs.io/ipfs/" + image.path}
//             style={{ maxWidth: "400px", margin: "15px" }}
//             key={image.cid.toString() + index}
//           />
//         ))}
//       </div>
//         </>
//       )} */}
//           </div>
//           </div>
//         </div>
//         <ToastContainer position="top-right" />
//     </div>
    
//   )
// }
// else{
//   console.log("NO")
        
//   return(
//     <div className="container">
// <p>You don't have permissions to access this page. Please connect your wallet.</p>
//     </div>
  
    
//   )
// }

// }



// export default Orders
import React, { useState } from 'react';
import UserSidebar from './Components/UserSidebar';
import { ethers } from 'ethers';
import Web3Modal from 'web3modal';
import { create as ipfsHttpClient } from 'ipfs-http-client';
import NFTMarketplace from '../artifacts/contracts/NFTMarketplace.sol/NFTMarketplace.json';
import nftmarketaddress from '../config';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { ThreeSixtyRounded } from '@mui/icons-material';
import {TestBAlert} from './Components/TestBAlert'
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
const fs = require('fs');

const Orders = () => {
  let imageUrl = '';
  const [minted, setMinted] = useState(false);
  const projectId = '2LYV9kyxorwvJiMS5DxpEOwLxMy';
  const projectSecret = 'c5927cc35e654ef1a4137d1ac95cf8dc';
  const authorization = 'Basic ' + btoa(projectId + ':' + projectSecret);
  const client = ipfsHttpClient({
    url: 'https://ipfs.infura.io:5001/api/v0',
    headers: {
      authorization,
    },
  });
  let wAddressLocalget = JSON.parse(localStorage.getItem('wAddressLocal'));
  console.log(wAddressLocalget);

  const navigate = useNavigate();
  const [fileUrl, setFileUrl] = useState(null);
  const [formInput, updateFormInput] = useState({
    price: '',
    name: '',
    description: '',
  });

  async function onChange(e) {
    const file = e.target.files[0];
    try {
      toast.info('Image will show once uploaded to IPFS');
      const added = await client.add(file);
      const url = `https://mint-blocks-nfts.infura-ipfs.io/ipfs/${added.path}`;
      setFileUrl(url);
      console.log(url);
    } catch (error) {
      console.log('Error uploading file: ', error);
      toast.error('Error uploading file to IPFS, try again');
    }
  }

  async function uploadToIPFS() {
    const { name, description, price } = formInput;
    if (!name || !description || !price || !fileUrl) {
      toast.error('Please fill in all fields and select an image.');
      return;
    }
    /* first, upload to IPFS */
    const data = JSON.stringify({
      name,
      description,
      image: fileUrl,
    });
    try {
      const added = await client.add(data);
      const url = `https://mint-blocks-nfts.infura-ipfs.io/ipfs/${added.path}`;
      imageUrl = fileUrl;
      
      return url;
    } catch (error) {
      console.log('Error uploading file: ', error);
      toast.error('Error uploading file to IPFS, try again');
      
    }
  }

  async function listNFTForSale() {
    const url = await uploadToIPFS();
    
    if (!url) {
      return;
    }

    // Check if there is a Web3 provider (i.e. Metamask) and if the user is connected
    if (typeof window !== 'undefined' && typeof window.ethereum !== 'undefined') {
      try {
        // Request user's permission to connect their Metamask account
        toast.info("Connecting to MetaMask please wait")
        await window.ethereum.request({ method: 'eth_requestAccounts' });

        // Initialize Web3Modal with the injected Ethereum provider from Metamask
        const web3Modal = new Web3Modal({
          network: 'mainnet', // Or the Ethereum network ID you want to connect to
          cacheProvider: true,
        });
        const connection = await web3Modal.connect();
        const provider = new ethers.providers.Web3Provider(connection);
        const signer = provider.getSigner();
        // Get the owner and seller addresses
        const ownerAddress = await provider.getSigner().getAddress();
        const sellerAddress = await provider.getSigner().getAddress();

        // Create the NFT item
        const contract = new ethers.Contract(nftmarketaddress, NFTMarketplace.abi, signer);
        const price = ethers.utils.parseUnits(formInput.price, 'ether');
        let listingPrice = await contract.getListingPrice();
        listingPrice = listingPrice.toString();
        let transaction = await contract.createToken(url, price, { value: listingPrice });
        toast.info("Your transaction is under process, please wait")
        let receipt = await transaction.wait();
        const tokenId = parseInt(receipt.logs[1].topics[3], 16); // Get the tokenId from the receipt
        console.log('tokenId', tokenId);
        // Create the data object to be sent to the database
        const data = {
          tokenId: tokenId,
          name: formInput.name,
          description: formInput.description,
          price: formInput.price,
          fileUrl: imageUrl,
          ownerAddress: ownerAddress,
          sellerAddress: sellerAddress,
          isApproved: false, //should be false in real, this is just for testing
        };

        // Send the data object to the database
        const response = await axios.post('https://mint-blocks-api-production.up.railway.app/nfts', data);
        console.log('Response from the server:', response.data);
        setMinted(true); // Set the minted state to true
        toast.success('NFT minted successfully and sent to admin for approval. You will be redirected to dashboard in 3 seconds');
        await sleep(5000);
        navigate('/user-dashboard/creator');
      } catch (error) {
        console.error('Error:', error);
        toast.error('An error occured, try again');
        if (error.response && error.response.data) {
          console.log('Validation errors:', error.response.data);
          toast.error('Validation errors, try again');
        }
      }
    } else {
      // Display an error message if the user is not connected to Metamask
      console.error('Please install Metamask or connect to the Ethereum network.');
      toast.error('Please install Metamask or connect to the Ethereum network.');
    }
  }

  if (wAddressLocalget !== null) {
    return (
      <div>

        <div className="container user-dashboard-page">
          <div className="user-sidebar">
            <UserSidebar />
          </div>
          <div className="user-main  container ms-3">
          <TestBAlert/>
            <div className="heading">
              <h3 className="mt-3">Add New NFT</h3>
              <form>
                <div className="form-group">
                  <label htmlFor="exampleFormControlInput1">Title</label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleFormControlInput1"
                    onChange={(e) => updateFormInput({ ...formInput, name: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group mt-2">
                  <label htmlFor="price">Price (Suitable price for Polygon Testnet Faucet is between 0.000001 to 0.000000009</label>
                  <input
                    type="number"
                    className="form-control"
                    id="price"
                    onChange={(e) => updateFormInput({ ...formInput, price: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group mt-2">
                  <label htmlFor="exampleFormControlTextarea1">Description</label>
                  <textarea
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    onChange={(e) => updateFormInput({ ...formInput, description: e.target.value })}
                    required
                  ></textarea>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlFile1">Image</label>
                  <br />
                  <input
                    type="file"
                    className="form-control-file"
                    id="exampleFormControlFile1"
                    name="Asset"
                    onChange={onChange}
                    required
                  />
                  {fileUrl && <img height="200px" src={fileUrl} alt="Nft image" />}
                </div>
                <small className="text-muted">Please upload a 1:1 image for the best preview.</small>
                <br />
                <button type="button" onClick={listNFTForSale} className="btn btn-primary mt-3">
                  Upload
                </button>
              </form>

              {minted && (
                <div className="alert alert-success mt-3" role="alert">
                  NFT minted successfully! It has been sent to the admin for approval.
                </div>
              )}
            </div>
          </div>
        </div>
        <ToastContainer position="top-right" />
      </div>
    );
  } else {
    console.log('NO');

    return (
      <div className="container">
        <p>You don't have permissions to access this page. Please connect your wallet.</p>
      </div>
    );
  }
};

export default Orders;
